import { isFeatureEnabledWithFallback } from '@/lib/featureEntitlements'

export type SocialInboxPlatform = 'instagram' | 'facebook'

export const SOCIAL_INBOX_FEATURE_KEYS: Readonly<Record<SocialInboxPlatform, string>> = Object.freeze({
  instagram: 'instagram_automation',
  facebook: 'facebook_posts',
})

export function socialInboxFeatureKey(platform: string | null | undefined): string | null {
  const p = String(platform || '').trim().toLowerCase()
  return p === 'instagram' || p === 'facebook' ? SOCIAL_INBOX_FEATURE_KEYS[p] : null
}

export function isSocialInboxPlatformEnabled(
  features: Record<string, boolean> | null | undefined,
  platform: string | null | undefined,
): boolean {
  const key = socialInboxFeatureKey(platform)
  if (!key) return true
  return isFeatureEnabledWithFallback(features, key)
}
